export const UPGRADE = {
  Info: 'Quero saber mais',
  Slip: 'Efetuar pagamento',
  Contract: 'Contrate com 1 clique',
  NonAdmin: 'ENVIAR E-MAIL PARA O ADMINISTRADOR DA CONTA',
  ConfirmAddon: (productName: string) => `Confirmar assinatura: ${productName}`,
};

export default UPGRADE;
